import { defineStore } from "pinia";

export const useLayoutStore = defineStore({
  id: "layout",
  state: () => ({
    sidebarStatus: false,
    loadingLayout: false,
    appBarTitle: "Partner Portal",
    historyMode: false,
    showHeaderBar: true,
  }),
  getters: {
    getSidebarStatus: (state) => state.sidebarStatus,
  },
  actions: {
    updateSidebarStatus(status) {
      this.sidebarStatus = status;
    },
    setAppBarTitle(title) {
      this.appBarTitle = title;
    },
    setHistoryMode(status) {
      this.historyMode = status;
    },
    updateShowHeaderBar(status) {
      this.showHeaderBar = status;
    },
  },
});
